export const None = -1
export const Alert = 0 // payload: {type: "error" | "info" | "success", message: text}
export const GridPopoverVisible = 1
export const MaintenenceMode = 2
export const RefreshAITokenCount = 3
export const OpenAITokenModal = 4